import type { TripListResponse } from "../../types/operations/tripList.type";

export const mockTripList = {
  default: { trips: [] },
} satisfies Record<string, TripListResponse>;
